import dayjs from "dayjs";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";
import {
  DateRangePicker,
  DATE_FORMAT,
  type DateRangePickerValue,
  getDateRangeFromValue,
} from "../date-range-picker";

interface FormDateRangeFieldProps {
  placeholder?: string;
  showErrorMessage?: boolean;
}

function FormDateRangeField({
  placeholder = "Pick a date range",
  showErrorMessage = true,
}: FormDateRangeFieldProps) {
  const field = useFieldContext<{ startDate: string; endDate: string }>();
  const value = field.state.value;

  const pickerValue: DateRangePickerValue | undefined =
    value.startDate && value.endDate
      ? {
          type: "dateRange",
          dateRange: {
            from: dayjs(value.startDate, DATE_FORMAT.base),
            to: dayjs(value.endDate, DATE_FORMAT.base),
          },
        }
      : undefined;

  return (
    <div className="flex flex-col gap-2">
      <DateRangePicker
        type="compact"
        value={pickerValue}
        placeholder={placeholder}
        onChange={(nextValue) => {
          const resolvedRange = getDateRangeFromValue(nextValue);

          field.handleChange({
            startDate: resolvedRange.from.format(DATE_FORMAT.base),
            endDate: resolvedRange.to.format(DATE_FORMAT.base),
          });
        }}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormDateRangeField };
